import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { removeToken } from "../../../shared/utils";

export interface UserState {
  aId?: string;
  isLogin: boolean;
  isSpeedMate: boolean;
  accountRevision: number;
}
const initialState: UserState = {
  aId: undefined,
  isLogin: false,
  isSpeedMate: false,
  accountRevision: 0,
};
const modalSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    addUser: (state, action: PayloadAction<string>) => {
      state.aId = action.payload;
      state.isLogin = true;
      state.accountRevision += 1;
    },
    updateUserInfo: (state) => {
      state.accountRevision += 1;
    },
    removeUser: (state) => {
      state.isLogin = false;
      removeToken("tirepick_repairshop_access_token");
      removeToken("repairshop_user");
    },
    checkSpeedMate: (state) => {
      state.isSpeedMate = true;
    },
  },
});
const { actions, reducer } = modalSlice;
export const { addUser, removeUser, checkSpeedMate } = actions;
export const { updateUserInfo } = actions;

export default reducer;
